import { Button, IconButton } from "@mui/material";
import { ArrowBackIcon, LogoutIcon, SearchIcon, SettingsIcon } from "../icons";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  helpFixState,
  localFileState,
  openHelpState,
  autoFillDataState,
} from "../recoil";
import { t } from "i18next";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

// 도움말
export const HelpButton = () => {
  const [openHelp, setOpenHelp] = useRecoilState(openHelpState);
  const [helpFix, setHelpFix] = useRecoilState(helpFixState);

  const handleHelpClick = () => {
    if (helpFix) {
      setOpenHelp(false);
      setHelpFix(false);
    } else {
      setOpenHelp(!openHelp);
    }
  };

  return (
    <IconButton
      // variant="outlined"
      sx={{
        color: "var(--icon-color)",
        borderColor: "black",
        // ml: "20px",
        p: 0,
        gap: 1,
        // "&:hover": {
        //   borderColor: "var(--header-hover-bg)",
        //   background: "var(--header-hover-bg)",
        // },
      }}
      onClick={handleHelpClick}
    >
      {/* <HelpOutlineIcon onClick={handleHelpClick} /> */}
      <HelpOutlineIcon />
      {/* {t("Help")} */}
    </IconButton>
  );
};

// 뒤로가기
export const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").filter(Boolean);

    if (path.length === 3 && path[0] === "project" && path[2] === "analysis") {
      sessionStorage.setItem("enteredFromAnalysis", "true");
    }

    if (path.length === 2 && path[0] === "project") {
      sessionStorage.removeItem("enteredFromAnalysis");
    }
  }, [location]);

  const handleBackClick = () => {
    const path = location.pathname.split("/").filter(Boolean);
    const fromAnalysis =
      sessionStorage.getItem("enteredFromAnalysis") === "true";

    if (
      path[0] === "project" &&
      (path.length === 2 || (path.length === 3 && path[2] === "analysis"))
    ) {
      return navigate("/home");
    }

    if (
      path[0] === "project" &&
      path.length === 3 &&
      fromAnalysis &&
      path[2] !== "analysis"
    ) {
      return navigate(`/project/${path[1]}/analysis`);
    }

    const newPath = "/" + path.slice(0, path.length - 1).join("/");
    navigate(newPath);
  };

  return (
    <Button
      variant="outlined"
      sx={{
        color: "var(--icon-color)",
        borderColor: "var(--icon-color)",
        minWidth: "30px",
        height: "30px",
        size: "small",
        p: 0,
        ml: 2,
        gap: 1,
        "&:hover": {
          borderColor: "var(--header-hover-bg)",
          background: "var(--header-hover-bg)",
        },
        "@media (max-width: 1550px)": {
          "& span": {
            display: "none",
          },
          width: "10px",
        },
      }}
      onClick={handleBackClick}
    >
      <ArrowBackIcon sx={{ fontSize: "20px" }} />
      <span>{t("BackToPath")}</span>
    </Button>
  );
};

// 로그아웃
export const LogoutButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const navigateLogin = () => {
    setOpen(false);
    navigate("/login");
  };

  const handleLogout = () => {
    const access_token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token");
    if (access_token) {
      localStorage.removeItem("access_token");
    }
    if (refresh_token) {
      localStorage.removeItem("refresh_token");
    }
    localStorage.removeItem("userInfo");
    navigate("/login");

    // return (
    // <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm">
    //   <DialogContent>{t("CheckLogout")}</DialogContent>
    //   <DialogActions>
    //     <Button color="inherit" size="small" onClick={navigateLogin}>
    //       {t("OK")}
    //     </Button>
    //   </DialogActions>
    // </Dialog>
    // );
  };

  return (
    <Button
      // variant="outlined"
      sx={{
        color: "black",
        borderColor: "black",
        size: "large",
        "&:hover": {
          borderColor: "var(--header-hover-bg)",
          background: "var(--header-hover-bg)",
        },
        // gap: 1,
      }}
      onClick={handleLogout}
    >
      <LogoutIcon />
      {/* {t("Logout")} */}
    </Button>
  );
};

// 프로젝트 생성-로컬파일 선택
export const LocalFileButton = () => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [files, setFiles] = useRecoilState(localFileState);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const selectedFiles = Array.from(event.target.files);
      setFiles(selectedFiles);
    }
  };

  return (
    <>
      <Button variant="contained" size="large" onClick={handleButtonClick}>
        {t("SelectLocalFile")}
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
        multiple
      />
    </>
  );
};
